import axios from 'axios';

function contactUs(data) {
  return axios.post(`${process.env.REACT_APP_MEOVAK_API_URL}/prospects`, data);
}
const notification = { contactUs };
export default notification;
